module.exports = __webpack_public_path__ + "img/tib.27d19034.png";